export function formatCardNumber(cardNumber?: string) {
  const result = cardNumber?.match(/.{1,4}/g);
  return result?.join(" ");
}
